import React from 'react';
import { Endpoint } from '../types';

interface PlaceholderProps {
  endpoint: Endpoint;
}

export function Placeholder({ endpoint }: PlaceholderProps) {
  return (
    <div className="alert alert-info">
      <h5 className="alert-heading">Próximamente</h5>
      <p className="mb-0">
        El formulario interactivo para
        {' '}
        <strong>{endpoint.name}</strong>
        {' '}
        (
        <code>{endpoint.path}</code>
        ) todavía no está implementado.
      </p>
    </div>
  );
}
